import './ProjectsListThumbs.scss';
import { observer } from 'mobx-react-lite';
import { Fragment, ReactElement, useContext } from 'react';
import { S_Pagination, S_PaginationProps } from '../../../../design/pagination/S_Pagination';
import { Settings } from '../../../../modules/settings/SettingsContext';
import { Loader } from '../../../components/Loader';
import { ListViewMode } from '../../user/user.store';
import { ProjectStatus } from '../projects.model';
import { IProjectListItem } from '../projects.store';
import { DraftProjectThumbItem } from './projectListItems/DraftProjectThumbItem';
import { ProjectThumbItem } from './projectListItems/ProjectThumbItem';

export interface IProjectsListThumbsProps {
  workspaceId: string;
  projects: IProjectListItem[];
  projectsListViewMode: ListViewMode;
  pagination: S_PaginationProps;
  isLoading: boolean;
  onDelete: (projectId: string) => Promise<void>;
  onGoToClarifications?: (projectId: string) => Promise<void>;
}

export const ProjectsListThumbs = observer((props: IProjectsListThumbsProps): ReactElement => {
  const context = useContext(Settings);

  const handleChange = async (pageNumber: number, pageSize: number): Promise<void> => {
    context.setProjectsCardsPageSize(pageSize);
    await props.pagination.onChange(pageNumber, pageSize);
  };

  const projects = props.projects.map((project) => (
    <Fragment key={project.id}>
      {project.status === ProjectStatus.Published && (
        <ProjectThumbItem
          id={project.id}
          name={project.name}
          description={project.description}
          imageCount={project.imagesCount}
          usersCount={project.usersCount}
          myRejectedCount={project.myRejectedCount}
          onProjectDelete={props.onDelete}
          workspaceId={props.workspaceId}
          unansweredClarificationsCount={project.unansweredClarificationsCount}
          onGoToClarifications={props.onGoToClarifications}
          projectRole={project.role}
        />
      )}
      {project.status === ProjectStatus.Draft && (
        <DraftProjectThumbItem
          id={project.id}
          name={project.name}
          description={project.description}
          publishReady={project.canBePublished}
          deleteDraft={props.onDelete}
          workspaceId={props.workspaceId}
          projectRole={project.role}
        />
      )}
    </Fragment>
  ));

  return (
    <Loader isLoading={props.isLoading}>
      <div className='project-list'>
        <div className='project-list-thumbs'>{projects}</div>
        <S_Pagination
          {...props.pagination}
          pageSize={context.store.projectsCardsPageSize}
          onChange={handleChange}
          pageSizeLabel='pagination.showItems'
        />
      </div>
    </Loader>
  );
});
